export default __webpack_public_path__ + "static/media/stairway.969ef3b4.webp";